export default __webpack_public_path__ + "static/about-kalbio-1-4944ab9e6002698ba1bf91f0e1223fe2.webp";